import { ActionIcon, Group, Text } from '@mantine/core';
import { Minus, Plus } from 'react-feather';

interface CountStepperProps {
  value: string;
  onDecrement: () => void;
  onIncrement: () => void;
  decrementLabel: string;
  incrementLabel: string;
  decrementDisabled?: boolean;
  incrementDisabled?: boolean;
  /** Width reserved for the value, so rows line up. */
  valueWidth?: number;
  size?: 'sm' | 'md';
}

/** "− n +" control used for group counts, type counts and per-value limits. */
export function CountStepper({
  value,
  onDecrement,
  onIncrement,
  decrementLabel,
  incrementLabel,
  decrementDisabled,
  incrementDisabled,
  valueWidth = 40,
  size = 'md',
}: CountStepperProps) {
  const iconSize = size === 'md' ? 14 : 12;
  return (
    <Group gap={8} wrap="nowrap" justify="center">
      <ActionIcon
        variant="default"
        size={size === 'md' ? 32 : 26}
        aria-label={decrementLabel}
        disabled={decrementDisabled}
        onClick={onDecrement}
      >
        <Minus size={iconSize} />
      </ActionIcon>
      <Text ta="center" fw={600} w={valueWidth} size="sm">
        {value}
      </Text>
      <ActionIcon
        variant="default"
        size={size === 'md' ? 32 : 26}
        aria-label={incrementLabel}
        disabled={incrementDisabled}
        onClick={onIncrement}
      >
        <Plus size={iconSize} />
      </ActionIcon>
    </Group>
  );
}
